import { Location } from "react-router-dom"
import {IndiInfo} from "../topola"
import * as queryString from "query-string"
import {ParsedQuery} from "query-string"
import {GedcomLanguage as Language} from "../model/gedcom-language"
import {ChartType} from "../chart"
import {DataSourceEnum, DataSourceSpecs} from "../datasource/data-source-specs"
import {Config} from "../config"
import {argsToConfig} from "./config-utils"


/**
 * Arguments passed to the application through URL parameters.
 */
export interface Arguments {
    sourceSpec?: DataSourceSpecs
    selection?: IndiInfo
    chartType: ChartType
    freezeAnimation: boolean
    showSidePanel: boolean
    config: Config
}

/**
 * Retrieve arguments passed into the application through the URL and uploaded data.
 */
export function getArguments(location: Location, allLanguages: Language[]): Arguments {
    let sourceSpec: DataSourceSpecs | undefined = undefined
    const chartTypes = new Map<string | undefined, ChartType>([["relatives", ChartType.Relatives]])
    const search = queryString.parse(location.search)
    const getParam = (name: string) => getParamFromSearch(name, search)

    if (location.state?.hash)
        sourceSpec = {
            source: DataSourceEnum.UPLOADED,
            hash: location.state?.hash,
            allLanguages: allLanguages,
            gedcom: location.state && location.state.data,
            images: location.state && location.state.images
        }

    const view = getParam("view")
    const indi = getParam("indi")
    const parsedGen = Number(getParam("gen"))
    const selection = indi ? {id: indi, generation: !isNaN(parsedGen) ? parsedGen : 0} : undefined

    return {
        sourceSpec,
        selection,
        chartType: chartTypes.get(view) || ChartType.Hourglass,
        showSidePanel: getParam("sidePanel") !== "false", // True by default.
        freezeAnimation: getParam("freeze") === "true",   // False by default
        config: argsToConfig(search)
    }
}

function getParamFromSearch(name: string, search: ParsedQuery) {
    const value = search[name]
    return typeof value === "string" ? value : undefined
}